import React from 'react';
import Card from '../../../../core/layout/Card';
import Separator from '../../../../core/layout/Separator';
import UnitRatingsListFilterContainer from './UnitRatingsListFilterContainer';
import UnitRatingsListContainer from './UnitRatingsListContainer';

const UnitRatingsListScene = () => (
  <div>
    <Card>
      <UnitRatingsListFilterContainer />
    </Card>
    <Separator />
    <Card title="Unit Ratings">
      <UnitRatingsListContainer />
    </Card>
  </div>
);

export default UnitRatingsListScene;
